import React from 'react';
import { ModalWistiaWrapper, WistiaResponsivePadding, WistiaResponsiveWrapper } from './styles';

type ModalVideoWrapperProps = {
  children: JSX.Element;
};

type ResponsiveVideoWrapperProps = {
  children: JSX.Element;
};

export function ModalVideoWrapper({ children }: ModalVideoWrapperProps) {
  return <div style={ModalWistiaWrapper}>{children}</div>;
}

export function ResponsiveVideoWrapper({ children }: ResponsiveVideoWrapperProps) {
  return (
    <div style={WistiaResponsivePadding} className="wistia_responsive_padding">
      <div style={WistiaResponsiveWrapper} className="wistia_responsive_wrapper">
        {children}
      </div>
    </div>
  );
}
